export default "skymp5-front/419adab058b0dcb0f85993d4427fb59a.png";